import { IDocumentLanguageField } from './models'

export const DATE_FORMAT = 'yyyy-MM-dd'

export const DOCUMENT_LANGUAGES: IDocumentLanguageField[] = [
  { language: 'en', label: 'English' },
  { language: 'de', label: 'Deutsch' },
  { language: 'es', label: 'Español' },
  { language: 'fr', label: 'Français' },
  { language: 'it', label: 'Italiano' },
  { language: 'pt', label: 'Português' },
]

export const START_FROM_TODAY = new Date()

export const UPLOAD_DOCUMENTS_ENDPOINT_BASE = '/api/v0/upload/apl/documents-upload'
